import { councilAppVersionApi } from "@/lib/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { UpdateAppVersionRequest } from "@/gen/api/backend/model"

const useUpdateCouncilAppVersion = (councilId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateAppVersionRequest) => {
      const response = await councilAppVersionApi.updateCouncilAppVersion(councilId, data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["council-app-version", councilId] })
    },
  })
}

export default useUpdateCouncilAppVersion